"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root(size) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("width:", size, "px;height:", size, "px;position:relative;> *{position:absolute;}")
  );
};

var imageContainer = function imageContainer(padding) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("left:", padding, "px;right:", padding, "px;top:", padding, "px;bottom:", padding, "px;")
  );
};

var _default = {
  root: root,
  imageContainer: imageContainer
};
exports.default = _default;